import { CopyAllSharp, Share, WhatsApp } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CardContent,
  Checkbox,
  Grid,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IconInfoCircle } from "@tabler/icons";
import { useMemo, useState } from "react";
import { LineWave } from "react-loader-spinner";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css"; // import first
import { axiosInstance } from "src/api/axios";
import PageContainer from "src/components/container/PageContainer";
import {
  FacebookIcon,
  GmailIcon,
  TelegramIcon,
  XIcon,
} from "../../assets/Icons";
import bgImage from "../../assets/images/backgrounds/login-bg.svg";

const EnrollFormPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [queries] = useSearchParams();
  const [parameters, setParameters] = useState({
    name: "",
    number: "",
  });
  // eslint-disable-next-line no-unused-vars
  const [products, setProducts] = useState();
  const [productImage, setProductImage] = useState("");
  const [leadData, setLeadData] = useState();
  const [hide, setHide] = useState(false);
  const [slide, toggleSlide] = useState(false);
  const [check1, setCheck1] = useState(true);
  const [check2, setCheck2] = useState(true);
  const { productId } = useParams();

  const whatsappShare = "https://api.whatsapp.com/send?text=";
  // const linkedinShare = 'https://www.linkedin.com/sharing/share-offsite/?url=';
  const facebookShare = "http://www.facebook.com/share.php?u=";
  const telegramShare = "https://telegram.me/share/url?url=";
  const xShare = `https://twitter.com/intent/post?url=`;
  const gmailShare = `mailto:?subject=${encodeURIComponent(
    "Create your own Account in few clicks"
  )}&body=`;
  const sm = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const theme = useTheme();
  useMemo(() => {
    axiosInstance.get(`product/${productId}`).then((response) => {
      if (response) {
        setProducts(response.data);
        if (response.data.images.length) {
          if (response.data.images.length >= 3) {
            setProductImage(response.data.images[2]);
          }
        }
        console.log(queries.get("direct"));
        if (queries.get("direct") === "true") {
          submit(false, true);
        }
        setLoader(false);

        if ("parameters" in response.data) {
          let newParams = { name: "", number: "", ...response.data.parameters };
          setParameters(newParams);
        }
      }
    });
  }, []);

  const submit = (formVisible = true, isIndirect = false) => {
    setLoader(true);
    const store = JSON.parse(localStorage.getItem("store"));
    try {
      const payload = {
        product_id: productId,
        user_id: store?.user?.user_id || store?.user?.id,
      };
      if (isIndirect) {
        payload.isDirect = true;
      } else {
        // console.log({ parameters });

        if (!parameters?.name || !parameters?.number) {
          setError("Name and Number are required");
          return;
        }

        let empty = Object.values(parameters).filter((i) => !i?.length);
        if (!formVisible) {
          empty.length = 0;
        }
        if (empty.length) {
          setError("All fields Must be filled with relevant information");
          setHide(false);
          return;
        }
        payload.name = parameters.name;
        payload.number = parameters.number;
        payload.parameters = parameters;
      }

      axiosInstance.post("/ref", payload).then((response) => {
        if (response?.data) {
          setLeadData(response.data);
          setSubmitted(true);
          setLoader(false);
          setHide(false);
        }
      });
    } catch (e) {
      console.log(e);
      // console.log(Object.keys(e.response));
      if ("response" in e && e.response.status_code >= 400) {
        setError(e.response.data.message);
      }
      setError("Something went wrong");
      setLoader(false);
      setHide(false);
    }
  };

  const generate_share_message = (leadData) => {
    console.log(products.lead_share_message);
    return encodeURIComponent(
      products?.lead_share_message
        ? products?.lead_share_message
            .replace("$url", leadData?.lead_url)
            .replace("$img", products?.lead_share_image || "")
        : `Hello, I have a Great offer for you, ${leadData?.lead_url}`
    );
  };
  if (loader) {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            height={"60vh"}
            style={{
              transform: "translate(35px ,0)",
            }}
          >
            <LineWave
              height={545}
              width={250}
              style={{ margin: "auto", marginLeft: "20px" }}
            />
          </Stack>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <PageContainer
        title="Add Lead Details | Earnpati"
        description="this is Lead Details form Page for Earnpati Offers"
      >
        <Grid container xs={12} style={{ minHeight: "70vh" }}>
          <Grid
            item
            lg={5}
            md={5}
            sm={0}
            xs={0}
            sx={{
              marginTop: sm ? 0 : "25vh",
              position: "sticky",
              top: { sm: "90vh", xs: "72vh", lg: "20vh" },
              bottom: sm ? "20px" : 0,
            }}
          >
            <img
              src={bgImage}
              alt=""
              width={"100%"}
              style={{ margin: "auto", display: sm ? "none" : "block" }}
            />
            <h4
              style={{
                marginLeft: { md: 45 },
                translate: sm ? "0 4rem" : 0,
                width: sm ? "95vw" : "auto",
                textAlign: "center",
              }}
            >
              Want to know how it works?{" "}
              <Link
                to={
                  "https://www.earnpati.com/know-more-about-how-share-link-works-in-earnpati"
                }
                target="_blank"
                rel="noopener"
                sx={{ fontWeight: 700, fontSize: "16px" }}
              >
                Click Here
              </Link>
            </h4>
          </Grid>
          <Grid item lg={7} md={7} xs={12}>
            <CardContent
              sx={{
                margin: sm ? 0 : 5,
                marginTop: { xs: -7, md: -1.5 },
                border: `2px solid ${theme.palette.earnpati.nav}`,
                borderRadius: "15px",
                padding: "9px",
                position: "relative",
              }}
            >
              {/*
               <img
                src={leaves}
                alt={'Leaves graphics for Earnpati'}
                style={{
                  width: 150,
                  position: 'absolute',
                  top: -20,
                  rotate: '280deg',
                  left: 0,
                  translate: '-50px -50px',
                  zIndex: 0,
                  display: 'none',
                }}
              />
              */}

              <form>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: "7.5px",
                    padding: "5px",
                    position: "relative",
                    zIndex: 3,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      maxHeight: "30vh",
                      height: "fit-content",
                      marginBottom: 0.4,
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    {productImage ? (
                      <img
                        src={productImage}
                        alt={""}
                        style={{
                          maxWidth: "100%",
                          width: "100%",
                          height: "100px",
                          borderRadius: "7.5px",
                        }}
                      />
                    ) : null}
                  </Grid>
                  {!submitted ? (
                    <>
                      <h3 style={{ marginLeft: "10px" }}>
                        Enter your customer details to generate tracking link
                      </h3>

                      {parameters
                        ? Object.entries(parameters).map((params) => (
                            <Grid item xs={12} spacing={4}>
                              <TextField
                                required
                                fullWidth
                                sx={{
                                  marginBottom: "1rem",
                                }}
                                onKeyDown={(e) =>
                                  e.key === "Enter" &&
                                  Object.values(parameters).filter(
                                    (i) => i.length
                                  ).length === Object.keys(parameters).length
                                    ? (setHide(true), submit())
                                    : console.log(
                                        Object.values(parameters).filter(
                                          (i) => i.length
                                        ).length
                                      )
                                }
                                id={params[0]}
                                label={
                                  params[0] &&
                                  params[0].toLowerCase() === "number"
                                    ? "Phone Number"
                                    : params[0].toLowerCase() === "name"
                                    ? "Name"
                                    : params[0]
                                }
                                type={
                                  params[0] &&
                                  (params[0].toLowerCase() === "number" ||
                                    params[0].toLowerCase().includes("pincode"))
                                    ? "number"
                                    : "text"
                                }
                                variant="outlined"
                                value={params[1]}
                                onChange={(e) => {
                                  let newParams = { ...parameters };
                                  newParams[params[0]] = e.target.value;
                                  setParameters(newParams);
                                }}
                              />
                            </Grid>
                          ))
                        : null}
                      <Grid item xs={12}>
                        <Stack spacing={2}>
                          <Typography variant="subtitle1" sx={{}}>
                            <Checkbox
                              checked={check1}
                              onClick={() => setCheck1(!check1)}
                              style={{ marginLeft: "-7px", color: "#000" }}
                            />
                            I agree that if i open multiple account from same
                            link then i will only able to see number of account
                            opening not each customers details
                          </Typography>
                          <Typography variant="subtitle1" sx={{}}>
                            <Checkbox
                              checked={check2}
                              onClick={() => setCheck2(!check2)}
                              style={{ marginLeft: "-7px", color: "#000" }}
                            />
                            To track each customer fill individual customer
                            leads
                          </Typography>
                        </Stack>
                      </Grid>

                      <Typography
                        variant="subtitle"
                        color={"red"}
                        sx={{ marginLeft: "7px" }}
                      >
                        {error}
                      </Typography>
                      <Grid item xs={12} spacing={2}>
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: theme.palette.earnpati.main,
                            fontWeight: 700,
                            display: hide ? "none" : "block",
                            marginBottom: ".2rem",
                            color: "white",
                            "&:hover": {
                              backgroundColor: theme.palette.earnpati.nav,
                              cursor: "pointer",
                            },
                          }}
                          size="large"
                          fullWidth
                          onClick={() => {
                            if (check1 && check2) {
                              setHide(true);
                              submit();
                            } else {
                              setError("All conditions must be accepted");
                            }
                          }}
                        >
                          Generate Link
                        </Button>
                        <Alert
                          sx={{
                            mt: 2,
                            bgcolor: "#FFF3E0",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                          variant="outlined"
                          icon={<IconInfoCircle color={"black"} />}
                        >
                          From one tracking link you can also open multiple
                          accounts
                        </Alert>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <h3
                        style={{ marginLeft: ".7rem", wordBreak: "break-word" }}
                      >
                        Your tracking link is generated share with your
                        Friends/Network
                      </h3>
                      <Grid item xs={12}>
                        <Stack direction={"row"} alignItems={"center"}>
                          <Box
                            sx={{
                              border: "1px solid #aaa",
                              padding: "7px 7px",
                              width: "calc(100% - 13.5rem)",
                              minWidth: sm ? "230px" : "250px",
                              marginLeft: ".6rem",
                              height: "3rem",
                              overflowX: "hidden",

                              overflowY: "hidden",
                              wordBreak: "break-word",
                              whiteSpace: "nowrap",
                              borderRadius: "24px",
                            }}
                          >
                            <Typography
                              sx={{
                                position: "relative",
                              }}
                            >
                              <svg
                                width="16px"
                                height="16px"
                                style={{
                                  marginRight: "3px",
                                  marginBottom: "-3px",
                                  position: "absolute",
                                  top: "7px",
                                  left: "4px",
                                }}
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M22.0545 5.94619C24.2785 8.17032 24.2785 11.7763 22.0545 14.0005L20.6067 15.4483C20.2943 15.7608 20.2943 16.2673 20.6067 16.5797L21.0862 17.0592C21.3986 17.3716 21.9051 17.3716 22.2175 17.0592L23.6653 15.6113C26.7789 12.4976 26.7789 7.44912 23.6653 4.33534C20.5517 1.22155 15.5035 1.22155 12.3898 4.33534L10.942 5.78321C10.6296 6.09563 10.6296 6.60218 10.942 6.91461L11.4215 7.39406C11.7339 7.70649 12.2404 7.70649 12.5528 7.39407L14.0006 5.94619C16.2246 3.72206 19.8305 3.72206 22.0545 5.94619Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M5.94601 22.0538C8.17004 24.278 11.7759 24.278 13.9999 22.0538L15.4477 20.606C15.7601 20.2935 16.2667 20.2935 16.5791 20.606L17.0585 21.0854C17.3709 21.3979 17.3709 21.9044 17.0585 22.2168L15.6107 23.6647C12.4971 26.7785 7.44886 26.7785 4.33523 23.6647C1.22159 20.5509 1.22159 15.5025 4.33523 12.3887L5.78303 10.9408C6.09544 10.6284 6.60197 10.6284 6.91438 10.9408L7.39382 11.4203C7.70623 11.7327 7.70623 12.2393 7.39382 12.5517L5.94601 13.9996C3.72198 16.2237 3.72198 19.8297 5.94601 22.0538Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M17.8593 9.80361C17.5078 9.45213 16.938 9.45213 16.5865 9.80361L9.80535 16.5851C9.45389 16.9366 9.45389 17.5064 9.80535 17.8579L10.1434 18.1959C10.4948 18.5474 11.0647 18.5474 11.4161 18.1959L18.1973 11.4145C18.5487 11.063 18.5487 10.4931 18.1973 10.1416L17.8593 9.80361Z"
                                  fill="#000000"
                                />
                              </svg>
                              <p
                                style={{
                                  width: "100%",
                                  overflowX: "scroll",
                                  margin: 0,
                                  padding: 0,
                                  height: "60px",
                                  marginLeft: "25px",
                                  marginTop: 0,
                                  paddingTop: "5px",
                                }}
                              >
                                {leadData
                                  ? leadData.lead_url
                                  : "We received an error, Please try again"}
                              </p>
                            </Typography>
                          </Box>
                          <Tooltip
                            title={copied ? "Copied" : "Copy"}
                            open={tooltip}
                            arrow
                            placement="top"
                          >
                            <Button
                              variant="text"
                              onMouseEnter={() => setTooltip(true)}
                              onMouseLeave={() => setTooltip(false)}
                              onFocus={() => setTooltip(true)}
                              onBlur={() => setTooltip(false)}
                              onClick={() => {
                                setCopied(true);
                                setTooltip(true);
                                setTimeout(() => {
                                  setCopied(false);
                                }, 2000);
                                navigator.clipboard
                                  .writeText(leadData?.lead_url)
                                  .then(() => {
                                    // toast.success('Copied Link', {
                                    //   position: 'bottom-center',
                                    // });
                                  });
                              }}
                            >
                              <CopyAllSharp
                                style={{ stroke: "#aaa", width: "2.5rem" }}
                              />
                            </Button>
                          </Tooltip>
                        </Stack>
                      </Grid>

                      {
                        //   <sub style={{ margin: '20px 0' }}>
                        //   Make Sure to follow Programs guidelines and Rules
                        // </sub>
                      }
                      <Grid item xs={12} sx={{ marginTop: "5rem" }}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          spacing={2}
                          justifyContent={"space-between"}
                          sx={{
                            position: "relative",
                          }}
                        >
                          <Button
                            startIcon={
                              <WhatsApp
                                style={{ width: "32px", height: "32px" }}
                              />
                            }
                            variant="contained"
                            sx={{
                              bgcolor: "##25D366",
                              padding: "5px",
                              height: "3rem",
                              minWidth: "45%",
                              maxWidth: "50%",
                              fontSize: "11px",
                              zIndex: 10,
                              background: "#25D366",
                              "&:hover": {
                                background: "#25D366",

                                cursor: "pointer",
                              },
                            }}
                            href={`${whatsappShare}${generate_share_message(
                              leadData
                            )}`}
                            target="_blank"
                          >
                            Share Via WhatsApp
                          </Button>
                          <Box
                            style={{
                              width: sm ? "15rem" : "10.5rem",
                              zIndex: 1,
                              display: "grid",
                              opacity: slide ? 1 : 0,
                              height: "3rem",
                              border: "1px solid #999",
                              borderRadius: 5,
                              position: "absolute",
                              background: "#F2EFF9",
                              right: "20px",
                              transition:
                                "all .5s cubic-bezier(0.16, 0.69, 1, 1.5) , padding .7s cubic-bezier(0.16, 0.69, 1, 1.5) , opacity .2s cubic-bezier(0.16, 0.69, 1, 1.5) ",
                              padding: slide ? "0 1.5rem" : 0,
                              translate: slide ? "0 -5rem" : 0,
                            }}
                          >
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${telegramShare}${generate_share_message(
                                  leadData
                                )}}`}
                              >
                                <TelegramIcon />
                              </a>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${facebookShare}${generate_share_message(
                                  leadData
                                )}}`}
                              >
                                <FacebookIcon />
                              </a>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${xShare}${generate_share_message(
                                  leadData
                                )}}`}
                              >
                                <XIcon />
                              </a>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${gmailShare}${generate_share_message(
                                  leadData
                                )}}`}
                              >
                                <GmailIcon />
                              </a>
                            </Stack>
                          </Box>
                          <Button
                            startIcon={<Share />}
                            variant="contained"
                            color="primary"
                            sx={{
                              height: "3rem",
                              right: "14px",
                              paddingTop: "5px",
                              paddingLeft: "9px",
                              fontSize: "11px",
                              zIndex: 10,
                              width: "46%",
                              marginLeft: "5%",

                              background: theme.palette.earnpati.nav,
                              "&:hover": {
                                background: theme.palette.earnpati.nav,
                                cursor: "pointer",
                              },
                            }}
                            onClick={() => toggleSlide(!slide)}
                          >
                            Share Via Socials
                          </Button>
                        </Stack>
                      </Grid>
                    </>
                  )}
                </Grid>
              </form>
            </CardContent>
          </Grid>
        </Grid>
        <ToastContainer />
      </PageContainer>
    );
  }
};

export default EnrollFormPage;
